import * as React from "react";
import Svg, { Path } from "react-native-svg";

const UsersFilledIcon = (props) => {
  return (
    <Svg
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.21 8.979c0-2.402 1.928-4.348 4.305-4.348s4.304 1.946 4.304 4.348c0 2.401-1.927 4.348-4.304 4.348-2.377 0-4.304-1.947-4.304-4.348z"
        fill="#001533"
      />
      <Path
        d="M2.667 18.836c0-2.118 1.7-3.836 3.797-3.836h.345c.187 0 .373.03.55.088l.877.29a7.272 7.272 0 004.558 0l.876-.29c.178-.058.364-.088.55-.088h.345c2.098 0 3.798 1.718 3.798 3.836v1.216c0 .77-.553 1.428-1.306 1.552a40.196 40.196 0 01-13.085 0 1.568 1.568 0 01-1.305-1.552v-1.216z"
        fill="#001533"
      />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.509 3.568A4.278 4.278 0 0114.819 2c2.376 0 4.303 1.947 4.303 4.348 0 2.1-1.474 3.853-3.434 4.259.163-.521.25-1.076.25-1.651 0-2.683-1.908-4.916-4.429-5.388zm1.785 10.124l-.11.034a5.445 5.445 0 001.044-.776 7.272 7.272 0 002.87-.342l.876-.29c.177-.058.363-.088.55-.088h.345c2.098 0 3.798 1.718 3.798 3.837v1.215c0 .77-.553 1.428-1.306 1.552-.656.108-1.315.2-1.974.276v-.743c0-2.643-2.208-4.786-4.93-4.786h-.449c-.242 0-.483.038-.714.11z"
        fill="#001533"
      />
    </Svg>
  );
};

export default UsersFilledIcon;
